/* eslint-disable */
export default {
  rateExceeded: '已超出要求限制。應用程式將在 {ttl} 秒內恢復。',
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
